export default "__VITE_ASSET__WAQvQPVL__"